import React from "react";

import { documentoCss } from "./documentoCss";

/**
 * Folha A4 do romaneio de carregamento. Tudo que e data, checkbox e
 * assinatura sai EM BRANCO (preenchido a caneta). Cliente/pedido/ambientes/
 * itens vem preenchidos do romaneio.
 *
 * Renderizado dentro de #romaneio-print-papers (consumido por impressao.js
 * para imprimir/baixar PDF apenas a folha).
 */

const CHECK_CARREGAMENTO = [
  "Possui o projeto impresso?",
  "Possui salva-piso?",
  "Possui cantoneira de proteção?",
  "Realizou a conferência final?",
  "Possui o romaneio de entrega?",
  "Possui checklist de término de montagem?",
];

const CHECK_OBRA = [
  "Vídeo do local antes da entrega?",
  "Piso protegido?",
  "Portas protegidas?",
  "Tirou foto da caixa de ferragem?",
  "Tirou foto do projeto?",
  "Vídeo do imóvel depois da entrega?",
  "Fotografou o volume no ambiente?",
  "Existem avarias nas paredes? (se sim, fotografar)",
  "Existem avarias nas portas? (se sim, fotografar)",
];

const INK = "#15171c";
const FORTE = "#0B0F1A";
const MUT = "#6B7280";
const LINHA = "#9CA3AF";

function Caixa({ size = 13 }) {
  return (
    <span
      style={{
        width: size, height: size, flex: "none", display: "inline-block",
        border: "1.4px solid #0B0F1A", borderRadius: 2,
      }}
    />
  );
}

const labelMut = {
  fontSize: "8pt", fontWeight: 700, letterSpacing: "0.08em",
  textTransform: "uppercase", color: MUT, marginBottom: 8,
};

export default function DocumentoRomaneio({ doc }) {
  const ambientes = doc.ambientes || [];
  return (
    <div id="romaneio-print-papers">
      {/* eslint-disable-next-line react/no-danger */}
      <style dangerouslySetInnerHTML={{ __html: documentoCss() }} />

      <div className="rmn-paper">
        {/* cabecalho */}
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 24 }}>
          <div>
            <div style={{ fontSize: "16pt", fontWeight: 700, color: FORTE }}>
              Romaneio de carregamento — Terceiros
            </div>
            <div style={{ fontSize: "9pt", color: MUT, marginTop: 3 }}>
              Marcenaria terceira · conferência e carregamento
            </div>
          </div>
          <div style={{ textAlign: "right", flex: "none" }}>
            <div style={{ fontSize: "8pt", color: MUT, textTransform: "uppercase", letterSpacing: "0.08em" }}>
              Nº do romaneio
            </div>
            <div style={{ fontSize: "13pt", fontWeight: 700, color: FORTE }}>{doc.numero || "—"}</div>
          </div>
        </div>
        <div style={{ height: 2, background: FORTE, margin: "12px 0 14px" }} />

        {/* identificacao */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 28px", marginBottom: 6, fontSize: "10pt" }}>
          <div style={{ display: "flex", gap: 6 }}>
            <span style={{ color: MUT, minWidth: 72 }}>Cliente:</span>
            <span style={{ fontWeight: 700, color: FORTE }}>{doc.cliente_nome || "—"}</span>
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            <span style={{ color: MUT, minWidth: 80 }}>Nº pedido:</span>
            <span style={{ fontWeight: 700, color: FORTE }}>{doc.num_pedido || "—"}</span>
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            <span style={{ color: MUT, minWidth: 72 }}>Marcenaria:</span>
            <span style={{ fontWeight: 700, color: FORTE }}>{doc.marcenaria || "—"}</span>
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            <span style={{ color: MUT, minWidth: 80 }}>Emissão:</span>
            <span style={{ fontWeight: 700, color: FORTE }}>{doc.emissao || ""}</span>
          </div>
        </div>
        <div style={{ display: "flex", gap: 6, alignItems: "flex-end", marginBottom: 18, fontSize: "10pt" }}>
          <span style={{ color: MUT, whiteSpace: "nowrap" }}>Data conferência / carregamento:</span>
          <span style={{ flex: 1, borderBottom: `1px solid ${LINHA}`, height: 14 }} />
        </div>

        {/* ambientes + itens */}
        {ambientes.map((amb, i) => (
          <div className="rmn-amb" key={i} style={{ marginBottom: 14 }}>
            <div style={{ fontSize: "11pt", fontWeight: 700, color: FORTE, borderBottom: "1px solid #D4D8E2", paddingBottom: 4, marginBottom: 8 }}>
              {amb.nome}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {(amb.itens || []).map((it, j) => (
                <div key={j} style={{ display: "flex", alignItems: "center", gap: 9 }}>
                  <Caixa />
                  <span style={{ color: INK }}>{it}</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* checklists */}
        <div className="rmn-block" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 22, marginTop: 18 }}>
          {[["Verificação no carregamento", CHECK_CARREGAMENTO], ["Verificação em obra", CHECK_OBRA]].map(([titulo, itens]) => (
            <div key={titulo}>
              <div style={labelMut}>{titulo}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                {itens.map((c) => (
                  <div key={c} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ flex: 1, color: INK, fontSize: "9.5pt" }}>{c}</span>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, color: MUT, fontSize: "8pt" }}>
                      <Caixa size={11} />SIM
                    </span>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, color: MUT, fontSize: "8pt" }}>
                      <Caixa size={11} />NÃO
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* observacoes */}
        <div className="rmn-block" style={{ marginTop: 18 }}>
          <div style={labelMut}>Observações</div>
          {doc.observacoes ? (
            <div style={{ color: INK, marginBottom: 8, whiteSpace: "pre-wrap" }}>{doc.observacoes}</div>
          ) : null}
          <div style={{ borderBottom: "1px solid #C9CDD6", height: 15 }} />
          <div style={{ borderBottom: "1px solid #C9CDD6", height: 15, marginTop: 8 }} />
        </div>

        {/* assinaturas */}
        <div className="rmn-block" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 36, marginTop: 30 }}>
          {["Conferência", "Carregamento"].map((t) => (
            <div key={t}>
              <div style={{ fontSize: "10pt", fontWeight: 700, color: FORTE, marginBottom: 18 }}>{t}</div>
              <div style={{ borderBottom: `1px solid ${FORTE}`, height: 1, marginBottom: 4 }} />
              <div style={{ fontSize: "8pt", color: MUT }}>Nome</div>
              <div style={{ borderBottom: `1px solid ${FORTE}`, height: 1, margin: "22px 0 4px" }} />
              <div style={{ fontSize: "8pt", color: MUT }}>Assinatura</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
